<template>
  <modal-box class="lottery-edit-numbers-modal" :title="'Edit Numbers'">
    <template #body>
      <div class="lottery-edit-numbers-modal__body">
        <div class="lottery-edit-numbers-modal__body__title">
          <p class="lottery-edit-numbers-modal__body__title__left">
            Total cost:
          </p>
          <p class="lottery-edit-numbers-modal__body__title__right">
            ~2.77884 SAUNA
          </p>
        </div>

        <div class="lottery-edit-numbers-modal__body__description">
          <p class="lottery-edit-numbers-modal__body__description__text">
            Numbers are randomized, with no duplicates among your tickets. Tap a
            number to edit it. Available digits: 0-9
          </p>
        </div>

        <div class="lottery-edit-numbers-modal__body__input-section">
          <div class="lottery-edit-numbers-modal__body__input-section__random">
            <button
              class="
                lottery-edit-numbers-modal__body__input-section__random__btn
              "
              @click="randomize"
            >
              Randomize
            </button>
          </div>

          <div class="lottery-edit-numbers-modal__body__input-section__tickets">
            <div
              class="
                lottery-edit-numbers-modal__body__input-section__tickets__ticket
              "
              v-for="(ticket, index) in tickets"
              :key="index"
            >
              <p
                class="
                  lottery-edit-numbers-modal__body__input-section__tickets__ticket__number
                "
              >
                #00{{ index + 1 }}
              </p>
              <input
                v-model="ticket.number"
                type="number"
                class="
                  lottery-edit-numbers-modal__body__input-section__tickets__ticket__input
                "
                :min="min"
                :max="max"
              />
            </div>
          </div>
        </div>
        <div class="lottery-edit-numbers-modal__body__bottom">
          <div class="lottery-edit-numbers-modal__body__bottom__ctas">
            <input-button
              class="rounded-sm"
              :size="'large'"
              :is-loading="isLoading"
              :disabled="quantity == 0"
              @click="buy"
              >{{ isLoading ? "Buying" : "Buy Instantly" }}</input-button
            >
            <button
              class="lottery-edit-numbers-modal__body__bottom__ctas__go-back"
              @click="goBack"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="
                  lottery-edit-numbers-modal__body__bottom__ctas__go-back__icon
                "
              >
                <path
                  fill-rule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clip-rule="evenodd"
                />
              </svg>
              <p
                class="
                  lottery-edit-numbers-modal__body__bottom__ctas__go-back__text
                "
              >
                Go Back
              </p>
            </button>
          </div>
        </div>
      </div>
    </template>
  </modal-box>
</template>

<script>
import ModalBox from "@/components/molecules/ModalBox";
import InputButton from "@/components/atoms/InputButton";

export default {
  name: "LotteryEditNumbersModal",
  components: {
    ModalBox,
    InputButton,
  },
  data() {
    return {
      isLoading: false,
      quantity: 1,
      tickets: [{ number: "123456" }, { number: "987654" }],
    };
  },
  computed: {
    min() {
      return 100000;
    },
    max() {
      return 999999;
    },
  },
  methods: {
    buy() {
      alert("buying");
    },
    viewOrEditNumbers() {
      this.$store.dispatch("openModal", "lottery-edit-numbers-modal");
    },
    randomize() {
      this.tickets = this.tickets.map((ticket) => {
        const number = Math.floor(100000 + Math.random() * 900000);
        ticket.number = number;
        return ticket;
      });
    },
    goBack() {
      this.$store.dispatch("openModal", "lottery-buy-tickets-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.lottery-edit-numbers-modal {
  font-size: 1.6rem;
  font-weight: normal;

  &__body {
    margin-right: 18px;
    margin-left: 18px;

    &__title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;

      &__left {
        font-size: 1.7rem;
        font-weight: 600;
      }
      &__right {
        font-size: 1.7rem;
      }
    }

    &__description {
      margin-bottom: 40px;
      &__text {
        text-align: justify;
      }
    }

    &__input-section {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      &__random {
        margin-bottom: 20px;
        &__btn {
          font-weight: 600;
          display: block;
          text-align: center;
          text-decoration: none;
          cursor: pointer;
          border: none;
          width: 100%;
          transition: $transition-common;
          background: #f4f2fc;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);
          -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);
          -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16);
        }
      }

      &__tickets {
        display: flex;
        flex-direction: column;
        gap: 20px;

        &__ticket {
          &__number {
            margin-bottom: 10px;
          }

          &__input {
            text-align: center;
            letter-spacing: 2.5rem;
            width: 100%;
            border-radius: 14px;
            padding: 4% 8%;
            background-color: #f4f2fc;
            box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;
            -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;
            -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.16) inset;
          }
        }
      }
    }

    &__bottom {
      padding-top: 20px;
      border-top: 1px solid #e9eaeb;
      &__ctas {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 20px;

        &__go-back {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 10px;
          &__text {
          }
          &__icon {
          }
        }
      }

      &__description {
        &__text {
        }
      }
    }
  }

  .rounded-sm {
    border-radius: 8px;
  }
}
</style>